import React from 'react';

// local dependencies
import { layoutConfig } from 'config/table-configs/prior-auth-list.js';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsPriorAuthorizationsEntityWidget as MemberDetailsPriorAuthorizationsEntityWidget } from 'ui/views/widgets/memberDetailsPriorAuthorizationsEntityWidget';
 *
 * // render
 * <MemberDetailsPriorAuthorizationsEntityWidget propName='propValue'/>
 */
const _memberDetailsPriorAuthorizationsEntityWidget = ( { componentData, requestPayload, onActionClick } ) => {
    return (
        <div className='ui-member-details-prior-authorizations-entity-widget'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ layoutConfig }
                tableResponse={ componentData }
                requestPayload={ requestPayload }
                onActionClick={ onActionClick }

                // sortFilterMode='offline'
                // searchFilter={ 'offline' }
                // disablePagination={ true }
            />
        </div>
    );
};

// set display name
_memberDetailsPriorAuthorizationsEntityWidget.displayName = 'memberDetailsPriorAuthorizationsEntityWidget';

// set default props
_memberDetailsPriorAuthorizationsEntityWidget.defaultProps = {};

// prop types
_memberDetailsPriorAuthorizationsEntityWidget.propTypes = {};


export const memberDetailsPriorAuthorizationsEntityWidgetPreloader = () => {
    return (
        <div className='ui-member-details-prior-authorizations-entity-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-prior-authorizations-entity-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsPriorAuthorizationsEntityWidgetPreloader.displayName = 'memberDetailsPriorAuthorizationsEntityWidgetPreloader';

// set default props
memberDetailsPriorAuthorizationsEntityWidgetPreloader.defaultProps = {};

// prop types
memberDetailsPriorAuthorizationsEntityWidgetPreloader.propTypes = {};


export const memberDetailsPriorAuthorizationsEntityWidget = withNetworkState( memberDetailsPriorAuthorizationsEntityWidgetPreloader, _memberDetailsPriorAuthorizationsEntityWidget );
